import { Injectable } from '@angular/core';
import { SessionManager } from './../session/service/session-manager';

@Injectable()
export class IntercomService {
  public appId = 'eq2my9w6';
  private identity: any;

  constructor(private sessionManager: SessionManager) {
  }

  public initialize() {
    this.sessionManager.getIdentity().subscribe((data: any) => {
      this.identity = data;
      const intercomData = {
        app_id: this.appId,
        email: this.identity.email,
        name: this.identity.firstName + ' ' + this.identity.lastName,
        user_id: this.identity.uuid,
        user_hash: this.identity.intercom
      };
      (<any>window).Intercom('boot', intercomData);
    });
  }
}
